import botIcon from "../photos/bot.png";
// import discoveryPageBg from "../photos/discoveryPageBg.svg";
import chatPageBg from "../photos/chatPageBg.svg";
import backIcon from "../photos/backIcon.svg";
import leftArrow from "../photos/leftArrow.svg";
import botWithBook from "../photos/botWithBook.svg";
import blurBackground from "../photos/blurBackground.png";
import searchContainerImgHeader from "../photos/searchContainerImgHeader.svg";
import arrowUpwards from "../photos/arrowUpwards.svg";
import loaderGif from "../gif/messageLoader.gif";
import redArrowRight from "../photos/red-arrow-right.svg";
import abcdIcon from "../photos/abcdIcon.svg";
import serviceIcon from '../photos/abcdServiceIcon.svg'
import searchIcon from "../photos/searchIcon.svg";
import sendArrow from "../photos/sendArrow.svg";
import botImg from "../photos/bot_img.png";
import dtChatPageBg from "../photos/dtChatPageBg.png";
import botImage from "../photos/bot-icon.png";
import topImg from "../photos/top-img.svg";
import dtDiscoveryPageBg from "../photos/dtDiscoveryPageBg.svg"
import chatIcon from '../photos/image5.svg'
const assetsMaanager = {
  // discoveryPageBg,
  chatIcon,
  backIcon,
  botIcon,
  leftArrow,
  botWithBook,
  blurBackground,
  searchContainerImgHeader,
  arrowUpwards,
  loaderGif,
  chatPageBg,
  redArrowRight,
  abcdIcon,
  serviceIcon,
  searchIcon,
  sendArrow,
  botImg,
  botImage,
  topImg,
  dtDiscoveryPageBg,
  dtChatPageBg
};
export default assetsMaanager
